module.exports = __webpack_public_path__ + "static/freshman-1-5f90628a43545c07509f81445849fe9e.jpg";